<script>
	export let alternating = false
	export let cls = null
</script>

<div
	class:grid-flow-dense={alternating}
	class="{cls} content-center items-start md:grid md:grid-cols-12"
>
	<div class="col-span-4 {alternating ? 'order-2' : ''} ">
		<slot name="image" />
	</div>
	<div class="items-top col-span-8 grid grid-cols-8 {alternating ? 'order-1' : ''}">
		<div class="quotationmark col-span-1">
			<div class="center text-8.5xl font-light text-neutral-300">&ldquo;</div>
		</div>
		<figure class="col-span-6 xl:col-span-5">
			<blockquote class="my-16 text-1.5xl font-normal italic leading-relaxed">
				<slot name="text" />
			</blockquote>
			<figcaption>
				<div class="bold text-base">
					<slot name="cite" />
				</div>
				<cite class="text-xs uppercase not-italic">
					<slot name="position" />
				</cite>
			</figcaption>
		</figure>
		<div class="quotationmark col-span-1 flex items-end">
			<div class="center text-8.5xl font-light text-neutral-300">&rdquo;</div>
		</div>
	</div>
</div>
